/**
   * Counts the number of combo's with and without quantity.
   * @param combos
   * @return {{withQuantity: *, withoutQuantity: *}}
   */
export function countCombosWithAndWithoutQuantity(combos) {
  // TODO pdp-10 merge with new function
  return {
    withoutQuantity: combos.filter((combo) => combo.quantity === 0),
    withQuantity: combos.filter((combo) => combo.quantity !== 0),
  };
}
export const getConfigPerCombo = (combos, comboAttributes, singleAttributes) => combos.map((combo) => {
  // Map the singleAttribute to allAttributes for combo, while updating the quantity to combo.quantity.
  const allAttributesForCombo = Object.values(singleAttributes).map((singleAttribute) => {
    if (singleAttribute.name === 'Quantity___LOV') {
      return {
        ...singleAttribute,
        value: combo.quantity,
      };
    }
    return singleAttribute;
  });

  // Add the attributes & their values specific to this combo to allAttributesForCombo.
  Object.values(comboAttributes).forEach((comboAttribute) => {
    allAttributesForCombo.push({
      ...comboAttribute,
      // Fetch the appropriate value for this particular attribute in the combo
      value: combo.attributes.find(
        (comboValue) => comboValue.attributeId === comboAttribute.name,
      ).attributeValue,
    });
  });

  // Yield the lineItem for this specific combo.
  return allAttributesForCombo;
});
